import { lazy } from "react";

import { RouteType } from "types/index";
import { routePaths } from "routes/constants";

const SearchStaff = lazy(() => import("pages/KensakuKun/SearchStaff/View"));
const SearchEmployee = lazy(
  () => import("pages/KensakuKun/SearchEmployee/View")
);
const SearchClient = lazy(() => import("pages/KensakuKun/SearchClient/View"));
const SearchCorporation = lazy(
  () => import("pages/KensakuKun/SearchCorporation/View")
);
const SearchJobListing = lazy(
  () => import("pages/KensakuKun/SearchJobListing/View")
);

export const kensakuKunRoutes: RouteType[] = [
  {
    path: routePaths.root.ken.root,
    redirect: routePaths.root.ken.staff.root,
    requiredAuth: true,
    superAdminOnly: false,
    element: <SearchStaff />,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.ken.staff.root,
    requiredAuth: true,
    superAdminOnly: false,
    element: <SearchStaff />,
    label: "search_staff",
  },
  {
    path: routePaths.root.ken.employee.root,
    requiredAuth: true,
    superAdminOnly: false,
    element: <SearchEmployee />,
    label: "search_employee",
  },
  {
    path: routePaths.root.ken.client.root,
    requiredAuth: true,
    superAdminOnly: false,
    element: <SearchClient />,
    label: "search_client",
  },
  {
    path: routePaths.root.ken.corporation.root,
    requiredAuth: true,
    superAdminOnly: false,
    element: <SearchCorporation />,
    label: "search_corporation",
  },
  {
    path: routePaths.root.ken.jobListing.root,
    requiredAuth: true,
    superAdminOnly: false,
    element: <SearchJobListing />,
    label: "search_job_listing",
  },
];
